import { useState } from 'react';

export default function SubscribeShell() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [tip, setTip] = useState('');

  const handleClick = () => {
    if (email.trim() === '' || !email.includes('@')) {
      setTip('请填写一个有效的邮箱地址');
      return;
    }
    setTip('');
    setDone(true);
  };

  return (
    <section id="subscribe" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-300 lg:grid-cols-12">
          {/* 左：文案 */}
          <div className="bg-secondary-950 p-6 md:p-9 lg:col-span-7">
            <span className="inline-block rounded-sm bg-accent-500 px-2.5 py-1 font-label text-[11px] font-bold tracking-widest text-secondary-950">
              运营栏
            </span>
            <h3 className="mt-4 font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
              每天一早，把昨天的热议与态度
              <br className="hidden md:block" />
              整理成一份摘要送到你面前
            </h3>
            <p className="mt-3 max-w-xl font-body text-sm leading-relaxed text-background-50/70">
              只发观点汇总与后续进展，不做结论、不煽动情绪。随时可以退出。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {['每日精选摘要', '话题位次变动', '后续追踪提醒'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-50/25 px-3 py-1 font-label text-xs text-background-50/80"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* 右：演示交互 */}
          <div className="flex flex-col justify-center bg-background-100 p-6 md:p-9 lg:col-span-5">
            {done ? (
              <div className="animate-fade-in flex flex-col items-start gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-check-line text-2xl text-primary-600" aria-hidden="true"></i>
                </span>
                <p className="font-heading text-lg font-black text-foreground-950">已加入订阅（演示）</p>
                <p className="font-body text-sm text-foreground-600">
                  这是页面演示效果，暂未接入真实发送。你可以随时修改这个区块的文案与形式。
                </p>
                <button
                  type="button"
                  onClick={() => {
                    setDone(false);
                    setEmail('');
                  }}
                  className="cursor-pointer font-label text-xs text-primary-600 underline underline-offset-4"
                >
                  再试一次
                </button>
              </div>
            ) : (
              <div>
                <label className="font-label text-xs font-medium text-foreground-600" htmlFor="sub-email">
                  邮箱地址
                </label>
                <div className="mt-2 flex flex-col gap-3 sm:flex-row">
                  <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-3">
                    <i className="ri-mail-line text-sm text-foreground-400" aria-hidden="true"></i>
                    <input
                      id="sub-email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      className="w-full bg-transparent font-label text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={handleClick}
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    订阅更新
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </button>
                </div>
                {tip && <p className="mt-2 font-label text-xs text-primary-600">{tip}</p>}
                <p className="mt-4 font-label text-[11px] leading-relaxed text-foreground-400">
                  演示用途：提交不会真实发送任何邮件，仅展示交互效果。
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}